module.exports = (__webpack_require__(24949))(2630);